import { useMemo, useState, useEffect } from 'react'
import { useAtom } from 'jotai'

import { Stack, StackDivider } from '@chakra-ui/react'

import { buildUrlString } from '@!/Util/buildUrlString'
import { ListItem } from '@!/Store/FeatureList/components'
import { userHashAtom } from '@!/atoms/userInfoAtom'
import { useCheckPurchasedBooks } from '@!/Hooks'
import { CircularProgressModal } from '@!/components/Modal'

export const BookListItem = ({ book, isPurchased }) => {
  const linkUrl = buildUrlString(`/store/books/${book.content_id}`)
  return (
    <ListItem
      title={book.full_name}
      imageUrl={book.image_url}
      authorName={book.author_name}
      publisherName={book.publisher_name}
      price={book.price}
      regularPrice={book.regular_price}
      sampleBookId={book.sample_book_id}
      contentId={book.content_id}
      adultFlag={book.adult_flag}
      sampleFilePath={book.sample_file_path}
      linkUrl={linkUrl}
      isPurchased={isPurchased}
    />
  )
}

export const BookList = ({ books }) => {
  const [userHash] = useAtom(userHashAtom)
  const contentIds = useMemo(() => books.map((book) => book.content_id), [books])
  const { data: purchasedBookIds, isSuccess: isSuccess, isLoading: isLoading } = useCheckPurchasedBooks(userHash, contentIds)
  const [listItems, setListItems] = useState(books)

  useEffect(() => {
    if (!isSuccess) return

    // content_idがpurchasedBookIdsに存在するかどうかをpurchasedに保存してlistItemsを更新
    setListItems(
      books.map((book) => {
        book.purchased = purchasedBookIds.some((purchasedBookId) => purchasedBookId == book.content_id)
        return book
      }),
    )
  }, [isSuccess])

  const canRender = useMemo(() => (!!userHash && isSuccess) || !userHash, [userHash, isSuccess])

  return (
    <Stack divider={<StackDivider />} spacing={0}>
      <CircularProgressModal isOpen={isLoading} />
      {canRender && listItems.map((book, index) => <BookListItem key={`book-list-item-${index}`} book={book} isPurchased={book.purchased} />)}
    </Stack>
  )
}
